import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function UpdateReviewer({ showMessage, id, setShowUpdate }) {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [reviewer, setReviewer] = useState(null);

    useEffect(() => {
        // Fetch reviewer by ID
        fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getReviewerById&id=${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setReviewer(data.reviewer);
                    setTitle(data.reviewer.title);
                } else {
                    console.error(data.error);
                    showMessage("error", data.error || "Failed to load reviewer.");
                }
            })
            .catch(err => {
                console.error(err);
                showMessage("error", "Error fetching reviewer data.");
            });
    }, [id, showMessage]);

    useEffect(() => {
        // Session check
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
            method: 'GET',
            credentials: "include",
        })
            .then(response => response.json())
            .then(data => {
                if (data.success !== 'true') {
                    navigate("/dashboard/login");
                }
            })
            .catch(error => {
                console.error(error);
            });
    }, [navigate]);

    const updateReviewer = async () => {
        if (!title.trim()) {
            showMessage("error", "Title cannot be empty.");
            return;
        }

        // Only check if title changed
        if (reviewer && title === reviewer.title) {
            showMessage("info", "Nothing has changed.");
            return;
        }

        const formData = new FormData();
        formData.append('id', id);
        formData.append('title', title);

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=updateReviewer`, {
                method: 'POST',
                credentials: "include",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", data.success);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showMessage("error", data.error || "Update failed.");
            }
        } catch (err) {
            console.error(err);
            showMessage("error", "An error occurred during update.");
        }
    };

    const cancelUpdate = () => {
        setShowUpdate(false);
    };

    return (
        <div className='dash_update_records'>
            <label>1. Title</label><br />
            <input
                className='dash_input'
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            /><br />

            <br /><br />
            <div className='dash_buttons_wrapper'>
                <button className='dash_form_buttom' onClick={updateReviewer}>Update</button>
                <button className='dash_form_buttom dash_reset' onClick={cancelUpdate}>Cancel</button>
            </div>
        </div>
    );
}

export default UpdateReviewer;
